/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputTargetType
 */
export interface OutputTargetType {
    /**
     * 
     * @type {boolean}
     * @memberof OutputTargetType
     */
    deleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputTargetType
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputTargetType
     */
    name: string;
}

/**
 * Check if a given object implements the OutputTargetType interface.
 */
export function instanceOfOutputTargetType(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputTargetTypeFromJSON(json: any): OutputTargetType {
    return OutputTargetTypeFromJSONTyped(json, false);
}

export function OutputTargetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputTargetType {
    if (json == null) {
        return json;
    }
    return {
        
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputTargetTypeToJSON(value?: OutputTargetType | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'deleted': value['deleted'],
        'id': value['id'],
        'name': value['name'],
    };
}

